import { productListFilterAccordionSectionStyles } from "@insite/content-library/Widgets/ProductList/ProductListFilterAccordionSection";
import Plus from "@insite/mobius/Icons/Plus";
// import Minus from "@tdp-live/Assets/Icons/Minus";
import { css } from "styled-components";

productListFilterAccordionSectionStyles.accordionSection = {
    headerProps: {
        css: css`
            button {
                background: #FFFFFF 0% 0% no-repeat padding-box;
            }
        `,
    },
    titleTypographyProps: {
        color: "text.main",
    },
    toggleIconProps: {
        color: "text.main",
        src: Plus,
        size: 26,
    },
    collapseIconProps: {
        color: "text.main",
   //     src: Minus,
        size: 26,
    },
    expandIconProps: {
        color: "text.main",
        src: Plus,
        size: 26,
    },
};

productListFilterAccordionSectionStyles.checkBoxSelected = {
    color: "secondary.main",
};

productListFilterAccordionSectionStyles.checkBoxGroup = {
    css: css`
        width: 100%;
        padding-bottom: 0px;
        > legend:empty {
            display: none !important;
        }
    `,
};
